import { fetchEventExpansions } from '../api/expansions';
import { updateContent } from '../actions/content';
import { deepKeysToCamel } from 'js-utils/transformation';

export const addExpansionsToEventEntities = (entities, response) => {
    const eventIds = Object.keys(entities);
    const { events } = response;

    return eventIds.reduce((prev, eventId) => {
        let expandedEventEntity = {
            ...entities[eventId],
        };

        const expandedEvent = events.find(({ id }) => id === eventId);

        let series;
        let eventSalesStatus;
        let ticketAvailability;

        if (expandedEvent) {
            series = expandedEvent.series;
            eventSalesStatus = expandedEvent.event_sales_status;
            ticketAvailability = expandedEvent.ticket_availability;
        }

        if (series) {
            expandedEventEntity = {
                ...expandedEventEntity,
                series: deepKeysToCamel(series),
            };
        }

        if (eventSalesStatus) {
            expandedEventEntity = {
                ...expandedEventEntity,
                eventSalesStatus: deepKeysToCamel(eventSalesStatus),
            };
        }

        if (ticketAvailability) {
            expandedEventEntity = {
                ...expandedEventEntity,
                ticketAvailability: deepKeysToCamel(ticketAvailability),
            };
        }

        return {
            ...prev,
            [eventId]: expandedEventEntity,
        };
    }, {});
};

// The intent here is to manually apply expansions on the events in the store.
// This only applies to the initial server render.
// When we call the search endpoint from the user searching
// in the app, we already get the expansions.
// Skipping the expansions on the server is a performance optimization.
export const getEventExpansions = () => (dispatch, getState) => {
    const {
        content: { entities, entityContext },
        pagination,
        search,
    } = getState();

    const eventIdsInStore = Object.keys(entities);

    if (eventIdsInStore.length) {
        fetchEventExpansions(eventIdsInStore).then((response) => {
            // Take the event entities from the Redux store,
            // and then add the expanded information to them.

            const entitiesWithExpansionsAdded = addExpansionsToEventEntities(
                entities,
                response,
            );

            dispatch(
                updateContent({
                    entities: entitiesWithExpansionsAdded,
                    entityContext,
                    pagination,
                    searchCriterias: { ...search },
                }),
            );
        });
    }
};
